import React, { useEffect, useMemo, useState } from "react";
import NonlalinService from "../../services/nonlalin/NonlalinService";

const NonlalinDisposisi = ({ idDisposisi }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [ketDisposisi, setKetDisposisi] = useState('')

    useEffect(() => {
        const getDisposisi = async () => {
            const response = await nonLalinService.getDisposisiById(idDisposisi)
            // console.log(response)
            setKetDisposisi(response.data.ketDisposisi)
        }
        getDisposisi()
    }, [nonLalinService, idDisposisi])

    return (
        <>
            {ketDisposisi}
        </>
    )
}

export default NonlalinDisposisi